import React, { useState } from "react";
import { Form } from "react-bootstrap";
import './Message.scss';
import { runAssessmentList } from "../../../shared/settings/apiConfig";
const sideMenu = [
    {
        name:"All",
        count:0,
    },
    {
        name:"Unread",
        count:0,
    },
    {
        name:"Read",
        count:0,
    },
    {
        name:"Deleted",
        count:0,
    },
    {
        name:"Sent",
        count:0,
    }
]
export default function MessageList (props) {
    const [config, setConfig] = useState({
        name: 'assessment',
        url: runAssessmentList,
        columns: [
            { name: '', property: '', width: '50px', columnType: 'custom', customColumn: (event) => checkBox(event) },
            { name: 'User Name', property: 'clientid', sort: false, width: '200px' },
            { name: 'Messagea', property: 'runstatus', sort: false, width: '200px' },
            { name: 'Start Time', property: 'starttime', sort: false, width: '250px' },
            { name: 'End Time', property: 'endtime', sort: false, width: '250px' },
        ],
        field: ["id", "rundate", "scheduleddate", "starttime", "endtime", "runstatus", "clientid", "createddate", "modifieddate","assessmentname","code"],
        filter: [],
        sort: [{ "field": "id", "direction": "desc" }],
        pagination: true,
    });

    const checkBox = (value) => {
        return (
            <div>
                <Form>
                    <Form.Check className="d-flex align-items-center justify-content-center" type="checkbox" label="" value={value?.id}/>
                </Form>
            </div>
        )
    }
       

    return(
        <div>
            <text className='screen-head'>Messages</text>
            <div className="message-container">
                <text>Compose / Broadcast</text>
            </div>
        </div>
    )
}